import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            视频爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            独家视频直击51吃瓜爆料第一现场，眼见为实
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 group cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center group-hover:bg-foreground-950/30 transition-colors">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading text-foreground-900 mb-2 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次播放
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}